var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('ScrollSpyNav'),_c('aboutOurTeam'),_c('teacher'),_c('student'),_c('researchAssistant'),_c('ad1'),_c('researchDirection'),_c('partner'),_c('researchFindings'),_c('ad2'),_c('recruitment'),_c('contactUs'),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }